var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import HTTPError from '../services/http-error';
const getAuthHeaders = () => {
    var _a;
    const accessToken = sessionStorage.getItem('accessToken');
    const correlationId = (_a = sessionStorage.getItem('correlationId')) !== null && _a !== void 0 ? _a : '';
    return {
        Authorization: `Bearer ${accessToken}`,
        'X-SYF-Request-CorrelationId': correlationId,
        'X-SYF-Request-TrackingId': generateUUID()
    };
};
/**
 * useFetch hook returns a function that will make syf API calls. It will include required headers including authorization token and session id taken from sessionStorage.
 * @param config An MFE config object that includes apigee host names to use and an error callback in case of HTTP responses other than 200
 * @returns A function that wrapps fetch. This wrapper function automatically adds required headers to syf API calls, it also parses the response.
 */
const useFetch = (config) => {
    function fetchWrapper(url_1, init_1) {
        return __awaiter(this, arguments, void 0, function* (url, init, base = config.hosts.apigee, addAuth = true) {
            var _a;
            const fullUrl = new URL(url, base);
            const { headers = {} } = init, rest = __rest(init, ["headers"]);
            let contentType = 'application/json';
            if (!init.method || ((_a = init.method) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'GET') {
                contentType = 'text/plain';
            }
            const fetchOptions = Object.assign({ mode: 'cors', headers: {
                    'Content-Type': contentType,
                    Accept: 'application/json'
                } }, rest);
            if (addAuth) {
                fetchOptions.headers = Object.assign(Object.assign(Object.assign({}, fetchOptions.headers), headers), getAuthHeaders());
            }
            const response = yield fetch(fullUrl.toString(), fetchOptions);
            if (!response.ok) {
                const err = new HTTPError(response);
                config.apiErrorCallback(err);
                throw err;
            }
            if (response.status === 204) {
                return null;
            }
            try {
                const text = yield response.text();
                return JSON.parse(text);
            }
            catch (_e) {
                throw new HTTPError(response);
            }
        });
    }
    return fetchWrapper;
};
export default useFetch;
//# sourceMappingURL=use-fetch.js.map